<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>{{ type == 'tgx' ? '门店码' : '渠道码' }}管理</h4>
        <!-- <span class="f-s-14 c-m-l-15">备注信息</span> -->
      </div>
      <div class="c-flex">
        <el-input
          placeholder="请输入渠道名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          type="primary"
          @click="viewQR($event, null, 'tgx')"
          class="c-m-l-10"
          v-if="type == 'tgx'"
        >
          查看门店码
        </el-button>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增渠道</el-button>
        <el-button type="primary" @click="doSetting" class="c-m-l-10" v-if="type == 'tgx'">
          门店设置
        </el-button>
        <el-button type="primary" @click="bindChannelQR" class="c-m-l-10">
          扫码绑定渠道
        </el-button>
      </div>
    </div>
    <div class="content-table">
      <el-table ref="table" height="calc(100% - 50px)" :data="fpi.data" highlight-current-row>
        <el-table-column fixed="right" width="100px">
          <template slot-scope="scope">
            <el-dropdown>
              <el-button>
                操作
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <template v-if="type == 'tgx'">
                  <el-dropdown-item @click.native="viewQR($event, scope.row)">
                    查看渠道门店码
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="viewQR($event, scope.row, 'bd')">
                    查看渠道获客码
                  </el-dropdown-item>
                </template>
                <template v-else>
                  <el-dropdown-item @click.native="viewQR($event, scope.row, 'tg')">
                    查看渠道门店码
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="viewQR($event, scope.row)">
                    查看渠道获客码
                  </el-dropdown-item>
                </template>
                <el-dropdown-item @click.native="doEdit(scope.row)">编辑</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="渠道名称"></el-table-column>
        <el-table-column
          prop="phones"
          label="渠道用户手机号"
          :formatter="formatArr"
        ></el-table-column>
        <el-table-column prop="count" label="访客数量">
          <template slot-scope="scope">
            <el-link type="primary" @click="viewVisitors(scope.row._id)">
              {{ scope.row.count }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="orgName" label="渠道服务商"></el-table-column>
        <el-table-column prop="serviceResourceName" label="直达服务商"></el-table-column>
        <el-table-column prop="supervisorName" label="直达管家"></el-table-column>
        <el-table-column prop="memo" label="备注"></el-table-column>
        <template v-for="(item, i) in extFields">
          <!-- 判断是否在列表展示 -->
          <template v-if="!item.frontEndConfig.listHide">
            <!-- 关联字典表 -->
            <template v-if="item.valueOption">
              <!-- 级联 -->
              <el-table-column
                v-if="item.type == 'cascade'"
                :label="item.nameDisp"
                :key="i"
                width="150px"
                :prop="'exts.' + item.name"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{
                    item.frontEndConfig.multiple
                      ? osg.formatCascadeMultiple(
                          item.valueOption,
                          $util.isJson(scope.row.exts[item.name])
                            ? JSON.parse(scope.row.exts[item.name])
                            : scope.row.exts[item.name]
                        )
                      : osg.formatCascade(item.valueOption, scope.row.exts[item.name])
                  }}
                </template>
              </el-table-column>
              <!-- 多选 -->
              <el-table-column
                v-else-if="item.type == 'checkbox'"
                :label="item.nameDisp"
                :key="i"
                width="150px"
                show-overflow-tooltip
                :prop="'exts.' + item.name"
              >
                <template slot-scope="scope">
                  {{ formatArray(item.valueOption, scope.row.exts[item.name]) }}
                </template>
              </el-table-column>
              <!-- 下拉/单选 -->
              <el-table-column
                v-else
                :label="item.nameDisp"
                :key="i"
                width="120px"
                show-overflow-tooltip
                :prop="'exts.' + item.name"
              >
                <template slot-scope="scope">
                  {{ format(item.valueOption, scope.row.exts[item.name]) }}
                </template>
              </el-table-column>
            </template>
            <!-- 非关联字典表 -->
            <template v-else>
              <el-table-column
                :prop="'exts.' + item.name"
                :label="item.nameDisp"
                :key="i"
                width="120px"
                show-overflow-tooltip
              ></el-table-column>
            </template>
          </template>
        </template>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="fpi.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="fpi.rows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="fpi.total"
      ></el-pagination>
    </div>

    <el-dialog
      title="新增渠道"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="80px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item label="渠道名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="渠道用户手机号" prop="phones">
          <el-select
            clearable
            multiple
            filterable
            allow-create
            default-first-option
            v-model="formData.phones"
            placeholder="请手动输入手机号并选择"
          >
            <el-option
              v-for="item in options.phones"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道用户" prop="openIds">
          <el-select
            clearable
            multiple
            filterable
            allow-create
            default-first-option
            v-model="formData.openIds"
            @change="openidChange"
          >
            <el-option
              v-for="item in options.openIds"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="直达服务商" prop="serviceOrgId">
          <el-select
            clearable
            filterable
            v-model="formData.serviceOrgId"
            @change="getSRSupervisor()"
          >
            <el-option
              v-for="item in options.sRPartner"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="直达管家" prop="supervisorId">
          <el-select clearable filterable v-model="formData.supervisorId">
            <el-option
              v-for="item in options.sRSupervisor"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="memo">
          <el-input v-model="formData.memo"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="display: flex; justify-content: space-between">
        <el-button @click="doInit">取 消</el-button>
        <el-button type="primary" @click="doSave(null)">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="type == 'tgx' ? '门店码' : '获客码'"
      :visible.sync="openQRDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <div style="display: flex; align-items: center">
        分享二维码：
        <div class="qrcode" style="margin: 20px 0 0 10px" ref="qrCodeUrl"></div>
      </div>
      <div style="margin-top: 26px">
        <span>分享长链接：</span>
        <el-link :href="href" target="_blank">{{ `${href}` }}</el-link>
      </div>
      <div slot="footer" style="display: flex; justify-content: space-between">
        <span></span>
        <el-button type="primary" @click="openQRDetail = false">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="扫码绑定渠道"
      :visible.sync="openChannelQR"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <div style="display: flex; align-items: center">
        分享二维码：
        <div class="qrcode" style="margin: 20px 0 0 10px" ref="qrCodeUrl"></div>
      </div>
      <div style="margin-top: 26px">
        <span>分享长链接：</span>
        <el-link :href="href" target="_blank">{{ `${href}` }}</el-link>
      </div>
      <div style="margin-top: 26px">
        <i class="el-icon-info c_blue"></i>
        <span>渠道用户使用微信扫描此二维码，可登陆查看渠道访客。</span>
      </div>
      <div slot="footer" style="display: flex; justify-content: space-between">
        <span></span>
        <el-button type="primary" @click="openChannelQR = false">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="门店信息"
      :visible.sync="openPartnerDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="partnerFormData"
        :fields="extFieldsPartner"
        :options="options"
        ref="form"
        :upload="upload"
        labelWidth="160px"
        :area="area"
        @changeForm="osg.changeForm"
      >
        <template slot="address">
          <el-input
            v-model="partnerFormData.address"
            @blur="getGeocode(partnerFormData.address)"
          ></el-input>
        </template>
        <template slot="gpsPoint.longitude">
          <el-input
            v-model="partnerFormData.gpsPoint.longitude"
            disabled
            placeholder="根据地址自动生成"
          ></el-input>
        </template>
        <template slot="gpsPoint.latitude">
          <el-input
            v-model="partnerFormData.gpsPoint.latitude"
            disabled
            placeholder="根据地址自动生成"
          ></el-input>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSavePartner">确 定</el-button>
        <el-button
          @click="
            openPartnerDetail = false;
            partnerFormData = { gpsPoint: {}, exts: {} };
          "
        >
          取 消
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      id="zUserList"
      title="访客列表"
      :visible.sync="openVisitorsDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content-table">
        <el-table ref="tableVisitors" :data="visitorFpi.data" empty-text="暂无访客" height="50vh">
          <el-table-column prop="_id" label="编号" min-width="150px"></el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="负责人" placement="top-end">
                <i class="fa fa-user-tie" v-show="scope.row.isHead"></i>
              </el-tooltip>
              {{ scope.row.name }}
            </template>
          </el-table-column>

          <el-table-column prop="nickname" label="昵称"></el-table-column>
          <el-table-column prop="headimgurl" label="头像">
            <template slot-scope="scope">
              <img
                v-if="scope.row.headimgurl"
                :src="scope.row.headimgurl"
                style="width: 50px; height: 50px; border-radius: 50%"
                alt=""
              />
              <img
                v-else
                src="../../src/assets/user.png"
                style="width: 50px; height: 50px; border-radius: 50%"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="province" label="省"></el-table-column>
          <el-table-column prop="city" label="市"></el-table-column>
          <el-table-column prop="country" label="国家"></el-table-column>
          <el-table-column prop="from" label="渠道"></el-table-column>
          <el-table-column prop="shareUserId" label="推荐人"></el-table-column>
          <el-table-column prop="sharedUserCount" label="推荐人数量"></el-table-column>
          <el-table-column label="性别" width="100px">
            <template slot-scope="scope">
              <span>
                {{ scope.row.sex == 0 ? '未知' : format('sex', scope.row.sex) }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageVisitorsSizeChange"
          @current-change="pageVisitorsChange"
          :current-page="visitorFpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="visitorFpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="visitorFpi.total"
        ></el-pagination>
      </div>
      <div slot="footer">
        <!-- <el-button type="primary" @click="doSavePartner">确 定</el-button> -->
        <el-button @click="openVisitorsDetail = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
// import areajs from '../resources/js/area.js';
export default {
  name: 'DeclarationQRCode',
  data() {
    return {
      tenantId: '',
      profile: {},
      href: '',
      shortUrl: '',
      fpi: {},
      extFields: [], //渠道扩展
      extFieldsPartner: [], //伙伴扩展
      searchValue: '',
      openDetail: false,
      openChannelQR: false,
      openQRDetail: false,
      openVisitorsDetail: false, // 打开访客列表弹窗
      openPartnerDetail: false, //伙伴表单弹窗
      formData: {
        supervisorId: '',
        phones: [],
        openIds: [],
        exts: {}
      }, //渠道表单
      partnerFormData: { gpsPoint: {}, exts: {} }, //伙伴表单
      visitorFpi: {}, //访客列表
      rules: this.$util.rules,
      channelId: '',
      baseUrl: '',
      type: '',
      options: {
        codecfg_sex: { codeId: 'SEX' },
        phones: [],
        openIds: []
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      //地址
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      acount: {}
    };
  },
  mounted() {
    window.$this = this;
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    // this.href = location.href.replace('Declaration', 'h5/#/pages/extForm/extForm');
    // this.init();
    this.type = this.osg.param('type');
    this.acount = JSON.parse(sessionStorage['loginAccount']);
    this.queryLocationHost();
    this.doInit();

    // if (this.type == 'tgx') {
    //获取伙伴扩展
    this.getExtFieldsPartner();
    // }
    this.osg.getFields('channel', () => {
      this.osg.getFpi();
      this.getData();
      this.queryPartnerId();
      this.getSRPartner(); // 查询直达门店
    });
  },
  //引用父页面方法
  inject: ['logout', 'getProfile'],
  methods: {
    // init() {
    //   this.getProfileInfo();
    //   // this.getDemo();
    // },
    // //获取当前租户信息，生成二维码
    // getProfileInfo() {
    //   this.profile.user = JSON.parse(sessionStorage['entity'])._id; //租户管理员ID
    //   this.profile._id = JSON.parse(sessionStorage['entity']).tenantId; //租户账号ID
    //   this.$nextTick(() => {
    //     this.bindQRCode();
    //   });
    // },
    bindQRCode() {
      new QRCode(this.$refs.qrCodeUrl, {
        text: `${this.href}`,
        width: 200,
        height: 200,
        colorDark: '#333333', //二维码颜色
        colorLight: '#ffffff', //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    pageVisitorsSizeChange(pageSize) {
      this.visitorFpi.rows = pageSize;
      this.viewVisitors();
    },
    pageVisitorsChange(currentPage) {
      this.visitorFpi.page = currentPage;
      this.viewVisitors();
    },
    doInit() {
      this.openDetail = false;
      this.openQRDetail = false;
      this.formData = { supervisorId: '', phones: [], openIds: [], exts: {} };
      this.partnerFormData = { gpsPoint: {}, exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      let formData = this.$util.deepCopy(row);
      formData.supervisorId = formData.supervisorId || '';
      formData.phones = formData.phones || [];
      formData.openIds = formData.openIds || [];
      this.formData = formData;
      this.getUsers(formData.openIds);
      this.getSRSupervisor(true);
      this.openDetail = true;
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#or': this.searchValue,
        'regex:memo|string#or': this.searchValue,
        'regex:orgName|string#or': this.searchValue,
        'regex:serviceResourceName|string#or': this.searchValue,
        'regex:supervisorName|string#or': this.searchValue,
        'in:phones|array#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc',
        'is:state|integer#and': 1
      };
      //添加过滤器参数
      //   $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('channel/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doSave(callback) {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        this.osg.ajax('/channel/upsert.do', this.formData, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
          console.log(callback);
          if (callback) callback(res.data);
        });
      }
    },
    //查看访客列表
    viewVisitors(channelId) {
      this.channelId = channelId || this.channelId;
      this.openVisitorsDetail = true;
      this.osg.ajax(
        'user/queryZuser.do',
        {
          page: this.visitorFpi.page,
          rows: this.visitorFpi.rows,
          'is:tenantId|string#and': null,
          channelId: this.channelId
        },
        res => {
          this.visitorFpi = res;
          this.$nextTick(() => {
            this.$refs.tableVisitors.doLayout();
            this.$forceUpdate();
          });
        }
      );
    },
    //获取partnerId
    queryPartnerId() {
      this.osg.ajax(
        'basic/partner/queryPartnerId.do',
        {},
        res => {
          this.partnerId = res.data;
          this.href = `${this.baseUrl}${this.type}/?type=${this.type}&partnerId=${this.partnerId}`;
          if (!this.partnerId) {
            this.osg.toast('该用户没有所在的服务商！', 'warning');
            return;
          }
        },
        { noload: true }
      );
    },
    //获取伙伴扩展
    getExtFieldsPartner() {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'partner',
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          for (var item of res.data) {
            if (this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade') {
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
          }
          this.osg.codeoption(() => {
            this.extFieldsPartner = res.data.filter(item => {
              return item.frontEndConfig.setting;
            });
          });
        },
        { noload: true }
      );
    },
    //保存伙伴
    doSavePartner() {
      if (this.osg.validate('partnerFormData')) {
        this.$util.saveFormatExtField(this.extFieldsPartner, this.partnerFormData);
        this.osg.ajax(
          'basic/partner/upsert.do',
          { partnerStr: JSON.stringify(this.partnerFormData) },
          res => {
            this.osg.ajax(
              'basic/partner/updateOrgName.do',
              {
                partnerName: res.data.name,
                orgId: res.data.orgId
              },
              () => {
                this.openPartnerDetail = false;
                this.partnerFormData = { gpsPoint: {}, exts: {} };
                this.osg.toast('保存成功！');
              }
            );
          }
        );
      }
    },
    //基础（前缀）路径
    queryLocationHost() {
      this.osg.ajax(
        'config/queryLocationHost.do',
        {},
        res => {
          this.baseUrl = res.data;
        },
        { noload: true }
      );
    },
    //查看二维码
    viewQR(e, row, type) {
      type = type || (this.type ? this.type : 'bd');
      let orgId = (row && row.orgId) || this.acount.orgId;
      this.queryOrg(orgId, partnerId => {
        if (row) {
          this.href = `${this.baseUrl}${type}/?type=${type}&partnerId=${partnerId}&channelId=${row._id}`;
        } else {
          this.href = `${this.baseUrl}${type}/?type=${type}&partnerId=${partnerId || ''}`;
        }
        this.openQRDetail = true;
        this.$nextTick(() => {
          this.bindQRCode();
        });
      });
    },
    //扫码绑定渠道
    bindChannelQR() {
      this.href = `${window.location.origin}/fsgo/w/index/login?wxtype=x&tenantId=${this.tenantId}&href=http://s.fsgo365.cn/wzw333`;
      this.openChannelQR = true;
      this.$nextTick(() => {
        this.bindQRCode();
      });
    },
    //门店设置
    doSetting() {
      if (!this.partnerId) {
        this.osg.toast('该用户没有所在的服务商！', 'warning');
        return;
      }

      this.osg.ajax(`basic/partner/queryById/${this.partnerId}.do`, {}, res => {
        this.$util.renderExtField(this.extFieldsPartner, res);
        res.gpsPoint = res.gpsPoint || {};
        this.partnerFormData = res;
      });

      this.openPartnerDetail = true;
    },
    //查询org，返回org对象
    queryOrg(orgId, callback) {
      if (!orgId) {
        this.osg.toast('没有所在的服务商！', 'warning');
        return;
      }
      this.osg.ajax('org/queryById/' + orgId + '.do', {}, res => {
        if (callback) callback(res.partnerId);
      });
    },
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatArr(row, column, cellValue) {
      if (cellValue && Array.isArray(cellValue) && cellValue.length > 0) {
        return cellValue.join('、');
      } else {
        return;
      }
    },
    renderCompute(formula) {
      return eval(formula);
    },
    getUsers(openids) {
      if (openids.length == 0) {
        return;
      }
      this.osg.ajax(
        'user/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          'is:state|integer#and': 1,
          'in:openid|array#and': openids.toString()
        },
        res => {
          res.data.map(item => {
            item.label = item.nickname || item.name;
            item.value = item.openid;
          });
          this.options.openIds = res.data;
          this.$forceUpdate();
        }
      );
    },
    openidChange(openidArr) {
      // 判断请求到的openid是否选中,未关联user的openid不做联动
      let openidArray = this.options.openIds;
      for (let item of openidArray) {
        // item.value 即 item.openid
        if (openidArr.indexOf(item.value) == -1) {
          // 未选
          let index = this.formData.phones.indexOf(item.phone);
          if (index != -1) {
            // 同步删除手机号
            this.formData.phones.splice(index, 1);
          }
        } else {
          // 已选
          let index = this.formData.phones.indexOf(item.phone);
          if (index == -1) {
            // 同步添加手机号
            this.formData.phones.push(item.phone);
          }
        }
      }
    },
    // 直达服务商-查询伙伴类型的服务资源
    getSRPartner() {
      this.osg.ajax(
        'biz/serviceResource/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          resourceType: 'partner',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item.serviceCrewId;
          });
          this.options.sRPartner = res.data;
        }
      );
    },
    // 直达管家-查询管家类型的技师服务资源
    getSRSupervisor(edit) {
      if (!edit) {
        this.formData.supervisorId = '';
      }
      if (!this.formData.serviceOrgId) {
        this.options.sRSupervisor = [];
        this.$forceUpdate();
        return;
      }
      this.osg.ajax(
        'biz/serviceResource/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          resourceType: 'technician',
          orgId: this.formData.serviceOrgId,
          'in:resourceRoles|array#and': '1',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item.relatedRecordId;
          });
          this.options.sRSupervisor = res.data;
          this.$forceUpdate();
        }
      );
    },
    //获取地理编码
    async getGeocode(address) {
      if (!address) {
        this.partnerFormData.gpsPoint = {};
        this.partnerFormData.exts.citycode = '';
        this.partnerFormData.exts.address = '';
        return;
      }
      let str = '';
      if (this.$refs.form.$refs.area && this.$refs.form.$refs.area[0].getCheckedNodes()[0]) {
        let arr = this.$refs.form.$refs.area[0].getCheckedNodes()[0].pathLabels;
        if (arr && arr.constructor == Array) {
          for (let item of arr) {
            str += item;
          }
        }
      }
      this.partnerFormData.exts.address = str + address;
      this.osg.geocode(str + address, res => {
        if (!res) {
          this.partnerFormData.gpsPoint = {};
          this.partnerFormData.exts.citycode = '';
          return;
        }
        this.partnerFormData.gpsPoint = {
          longitude: res.location.split(',')[0],
          latitude: res.location.split(',')[1]
        };
        this.partnerFormData.exts.citycode = res.citycode;
        this.$forceUpdate();
      });
    }
  },
  watch: {
    $route() {
      window.$this = this;
      this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
      this.type = this.osg.param('type');
      this.acount = JSON.parse(sessionStorage['loginAccount']);
      this.queryLocationHost();
      this.doInit();

      this.getExtFieldsPartner();
      this.osg.getFields('channel', () => {
        this.osg.getFpi();
        this.getData();
        this.queryPartnerId();
        this.getSRPartner();
      });
    }
  }
};
</script>

<style>
#zUserList .el-dialog {
  width: 1100px;
}
</style>
